import React, { useState } from 'react';
import { Button, Chip, CircularProgress, Divider, ListItemIcon, Menu, MenuItem } from '@mui/material';
import {
  ArrowDropDown as ArrowDropDownIcon,
  DateRange as DateRangeIcon,
  Delete as DeleteIcon,
  EventBusy as EventBusyIcon,
  HourglassBottom as PartialIcon,
} from '@mui/icons-material';

/** Assenza del giorno selezionato: giornata intera, parziale o rimozione; onOpenDays apre la scelta su più giorni. */
export default function AbsenceMenu({ absence, disabled, onSet, onRemove, onOpenDays }) {
  const [anchor, setAnchor] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (fn) => {
    setAnchor(null);
    setBusy(true);
    try {
      await fn();
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {absence && (
        <Chip
          size="small"
          icon={<EventBusyIcon />}
          label={absence.full_day ? 'Absent all day' : 'Partially absent'}
          onDelete={disabled || busy ? undefined : () => run(onRemove)}
          sx={{
            fontWeight: 600,
            bgcolor: absence.full_day ? 'rgba(229,57,53,0.12)' : 'rgba(249,168,37,0.2)',
            color: absence.full_day ? 'var(--rt-danger-strong)' : 'var(--rt-amber)',
            '& .MuiChip-icon': { color: 'inherit' },
          }}
        />
      )}
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={(e) => setAnchor(e.currentTarget)}
        disabled={disabled || busy}
        startIcon={busy ? <CircularProgress size={16} color="inherit" /> : <EventBusyIcon fontSize="small" />}
        endIcon={<ArrowDropDownIcon />}
        sx={{ textTransform: 'none', borderColor: 'divider' }}
      >
        Absence
      </Button>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem selected={absence?.full_day === true} onClick={() => run(() => onSet(true))}>
          <ListItemIcon>
            <EventBusyIcon fontSize="small" />
          </ListItemIcon>
          Absent all day
        </MenuItem>
        <MenuItem selected={absence?.full_day === false} onClick={() => run(() => onSet(false))}>
          <ListItemIcon>
            <PartialIcon fontSize="small" />
          </ListItemIcon>
          Partially absent
        </MenuItem>
        {absence && (
          <MenuItem onClick={() => run(onRemove)}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            Remove absence
          </MenuItem>
        )}
        {onOpenDays && <Divider />}
        {onOpenDays && (
          <MenuItem
            onClick={() => {
              setAnchor(null);
              onOpenDays();
            }}
          >
            <ListItemIcon>
              <DateRangeIcon fontSize="small" />
            </ListItemIcon>
            Several days…
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
